import {
  AsyncAction,
  UserSpace,
  MeterRes,
  OptionalDate,
  Consumption,
} from 'models';
import services from 'services';
import * as ActionCreators from './action-creators';
import { format } from 'date-fns';

function buildConsumptionURL(
  startDate: OptionalDate,
  endDate: OptionalDate,
  cooperativeId: string,
  spaceId: string,
  meterId: string
) {
  let searchParams = '';

  if (startDate) {
    searchParams += `StartDate=${format(
      startDate,
      "yyyy-MM-dd'T'00:00:00.000"
    )}&`;
  }

  if (endDate) {
    searchParams += `EndDate=${format(endDate, "yyyy-MM-dd'T'00:00:00.000")}`;
  }

  return `/api/user/cooperatives/${cooperativeId}/spaces/${spaceId}/meters/${meterId}/consumption?${searchParams}`;
}

export const fetchSpaces = (currentCoop: string | null): AsyncAction => {
  return async (dispatch) => {
    dispatch(ActionCreators.requestConsumptionSpaces());

    try {
      const spaces: UserSpace[] = (
        await services.get(`/api/user/cooperatives/${currentCoop}/spaces`)
      ).data.Data;

      dispatch(ActionCreators.requestConsumptionSpacesSuccess(spaces));
    } catch (err) {
      console.error(err);
      dispatch(ActionCreators.setErrorStatus(true));
    }
  };
};

export const fetchMeters = (coopId: string, spaceId: string): AsyncAction => {
  return async (dispatch) => {
    dispatch(ActionCreators.requestMeters());

    try {
      const metersRes: MeterRes = (
        await services.get(
          `/api/user/cooperatives/${coopId}/spaces/${spaceId}/meters`
        )
      ).data.Data;

      dispatch(ActionCreators.requestMetersSuccess(metersRes.Meters));
    } catch (err) {
      console.error(err);
      dispatch(ActionCreators.setErrorStatus(true));
    }
  };
};

export const fetchConsumptions = (
  startDate: OptionalDate,
  endDate: OptionalDate,
  cooperativeId: string,
  spaceId: string,
  meterId: string
): AsyncAction => {
  return async (dispatch) => {
    dispatch(ActionCreators.requestConsumptions());

    try {
      const url = buildConsumptionURL(
        startDate,
        endDate,
        cooperativeId,
        spaceId,
        meterId
      );

      const consumptions: Consumption[] = (await services.get(url)).data.Data;

      dispatch(ActionCreators.requestConsumptionsSuccess(consumptions));
    } catch (err) {
      console.error(err);
      dispatch(ActionCreators.setErrorStatus(true));
    }
  };
};
